import React from "react";

// Styled Components
import { FooterContainer } from "../styles/footerStyles";

const Footer = () => {
  return (
    <FooterContainer>
      <p>Drag and drop to reorder list</p>
    </FooterContainer>
  );
};

export default Footer;
